import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button } from '@node-space/ui-components'

export const RecaptchaTokenError = () => {
  const { t } = useTranslation()

  return (
    <Box aria-label="recaptcha token error">
      <p className="text-body-regular text-foreground-prominent">
        {`${t('recaptcha.tokenError')} ${t('requestErrors.please')} `}
        <Button variant="ghost" onClick={() => window.location.reload()} noPadding>
          {`${t('requestErrors.refreshPage')} ${t('requestErrors.and')} ${t('requestErrors.tryAgainAction', { action: t('requestErrors.logIn') })}.`}
        </Button>
      </p>
    </Box>
  )
}
